import React from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';

import { isAuthChecked, isAuthenticated } from '../reducers/analyticsApp';

const PrivateRoute = ({ authChecked, authenticated, children }) => {
  // Лоадер, пока не завершён probe сессии либо пока идёт переаутентификация в попапе
  // (401 на probe -> ReauthModal, запрос повторяется после логина, см. api/authFetch).
  if (!authChecked || !authenticated) {
    return (
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return children;
};

const mapStateToProps = (state, props) => ({
  ...props,
  authChecked: isAuthChecked(state),
  authenticated: isAuthenticated(state),
});

export default connect(mapStateToProps)(PrivateRoute);
